<script>
  import { onMount, tick } from "svelte";
  import { createEventDispatcher } from "svelte";
  import FaTrashAlt from "svelte-icons/fa/FaTrashAlt.svelte";
  import FaRegEdit from "svelte-icons/fa/FaRegEdit.svelte";
  import FaBars from "svelte-icons/fa/FaBars.svelte";
  import IoIosCopy from "svelte-icons/io/IoIosCopy.svelte";
  import MenuItem from "./MenuItem.svelte";
  import FaAngleDown from "svelte-icons/fa/FaAngleDown.svelte";
  import FaAngleUp from "svelte-icons/fa/FaAngleUp.svelte";
  import FaRegEye from "svelte-icons/fa/FaRegEye.svelte";
  import FaRegEyeSlash from "svelte-icons/fa/FaRegEyeSlash.svelte";

  const dispatch = createEventDispatcher();

  export let item;
  export let section;

</script>

<main on:mouseenter class:justSaved={item.justSaved}>
  <div class="buttons">
    <div
      on:click|stopPropagation={() => {
        dispatch('moveUp', item);
      }}
      class="iconSquare"
    >
      <FaAngleUp />
    </div>
    <div
      on:click|stopPropagation={() => {
        dispatch('moveDown', item);
      }}
      class="iconSquare"
    >
      <FaAngleDown />
    </div>
    <div
      class="iconSquare"
      on:click|stopPropagation={() => {
        dispatch('deleteItem', item);
      }}
    >
      <FaTrashAlt />
    </div>
    <div
      on:click|stopPropagation={() => {
        dispatch('edit', item);
      }}
      class="iconSquare"
    >
      <FaRegEdit />
    </div>
    <div
      on:click|stopPropagation={() => {
        dispatch('copy', item);
      }}
      class="iconSquare"
    >
      <IoIosCopy />
    </div>
    <div
      on:click|stopPropagation={() => {
        dispatch('toggleHidden', item);
      }}
      class="iconSquare"
    >
      {#if item.hasOwnProperty('hidden') && item.hidden == true}
        <FaRegEye />
      {:else}
        <FaRegEyeSlash />
      {/if}
    </div>
  </div>
  <MenuItem {section} {item} />
</main>

<style>
  main {
    background: white;
    user-select: none;
    min-width: 50px;
    min-height: 50px;
  }
  .buttons {
    display: inline-flex;
    margin: 10px;
  }

  .iconSquare {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff2e;
    filter: brightness(0.9);
    background: #d8d8d82b;
    filter: brightness(0.7);
    border-radius: 4px;
    user-select: none;
    -webkit-user-drag: none;
    padding: 9px;
    box-sizing: border-box;
    color: #f1f1f1;
    margin-left: 10px;
    border: 2px solid #a9a9a90d;
    cursor: pointer;
  }
  .justSaved {
    animation-duration: 0.5s;
    animation-name: justSaved;
  }

  @keyframes justSaved {
    from {
      background-color: #d0f2ff;
    }

    to {
      background-color: white;
    }
  }

</style>
